<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row class="row pt-5">
        <v-col class="mt-sm-20" m="12" md="7" lg="7">
          <v-col align-self="center" class="mx-auto">
            <v-img src="@/assets/3881.jpg" class="mx-auto" width="200px;" />
          </v-col>

          <div>
            <br />
            Unlock Seamless Business Communication
            <br /><br />
            Welcome to Our Secure SMS Gateway Service!
            <br /><br />
            At Maritech Software Pte. Ltd., we understand the critical role
            effective communication plays in business success. That's why we've
            tailored our Secure SMS Gateway Service for ERP Integration,
            specifically crafted for the maritime industry. Whether you're a
            shipping company or a port operator, our solution empowers you to
            communicate effortlessly with customers and employees through secure
            text messaging.
          </div>
          <div class="pt-4">
            <h3>Key Features:</h3>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-card-account-details-outline </v-icon
            >&nbsp;
            <span class="sicon"><b>Secure Sender ID Registration:</b></span>
            <br />
            <p class="texv">
              Say goodbye to registration hassles. We manage Sender ID
              registration and government agency applications for recognizable
              sender IDs.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-arrow-decision </v-icon
            >&nbsp; <span class="sicon"><b>Flexible ERP Integration:</b></span>
            <br />
            <p class="texv">
              Seamlessly integrate with ERP systems like NetSuite for fluid
              communication between your business, customers, and employees.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-form-textbox-password</v-icon
            >&nbsp;
            <span class="sicon"><b>One-Time Password (OTP) Support:</b></span>
            <br />
            <p class="texv">
              Enable secure transactions and access with OTPs for approvals or
              account authentication.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-weather-cloudy</v-icon
            >&nbsp; <span class="sicon"><b>Cloud-Based Scalability:</b></span>
            <br />
            <p class="texv">
              Scale effortlessly to meet your business's growing needs with our
              cloud-based platform.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-currency-usd</v-icon
            >&nbsp; <span class="sicon"><b>Affordable Pricing Model:</b></span>
            <br />
            <p class="texv">
              Pay only for what you use, making our service cost-effective for
              all your communication requirements.
            </p>
            <br />
            <v-icon color="indigo darken-4" x-large>
              mdi mdi-message-cog-outline</v-icon
            >&nbsp; <span class="sicon"><b>Comprehensive SMS Logs:</b></span>
            <br />
            <p class="texv">
              Integrate SMS logs with your analytics tools for valuable insights
              into campaign effectiveness.
            </p>
            <br />
            <p>
              Our Secure SMS Gateway Service is the linchpin for streamlined
              communication in the maritime industry. Leave the complexities to
              us while you focus on business growth. Contact us today to explore
              how our service can transform your communication landscape.
            </p>
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div></div>
          Get hands-on experience with our solution! Fill in the details below,
          and let's embark on a 15-minute demo tailored to your needs.
          <br />
          Maritech Software Pte. Ltd. Singapore
          <div class="text-center pt-5">
            <strong>
              "A one-size-fits-all approach is not effective for either shoes or
              software. Both need to be tailored to the individual user or
              business to be truly effective."</strong
            >
          </div>
        </v-col>
      </v-row>

    </v-container>

  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = " Secure SMS Gateway Service for ERP Integration";
  }
};
</script>

<style scoped>
.row {
  text-align: justify;
}
h3 {
  font-size: 20px;
  color: rgb(3, 50, 97);
}

.pt-4 {
  text-align: justify;

}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}
</style>
